export class HtmlEntities {

	static encode(str: string): string {
		return str
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	}

	static decode(str: string): string {
		return str
			.replace(/&lt;/g, '<')
			.replace(/&gt;/g, '>');
	}

}
